function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class AddToCart extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form[action$="/cart/add"]');
        this.productIdInput = this.form?.querySelector("[name=id]");
        this.addButtons = this.querySelectorAll('button[name="add"]');

        if (this.form && this.productIdInput) {
          this.productIdInput.disabled = false;
          this.form.addEventListener("submit", this.formSubmit.bind(this));
        }
      }

      async formSubmit(evt) {
        evt.preventDefault();

        if (!this.productIdInput?.value) {
          this.variantError();
          return;
        }

        document.querySelector(".product-error")?.remove();
        this.removeErrorsBlock();
        this.toggleLoadingState(true);

        try {
          const config = {
            ...fetchConfig("javascript"),
            body: new FormData(this.form),
          };
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];

          const response = await fetch("/cart/add", config);
          const data = await response.json();

          if (data.status) {
            this.errorMessage(data);
            return;
          }

          this.success();
        } catch (error) {
          console.error("Add to cart error:", error);
          this.toggleLoadingState(false);
        }
      }

      toggleLoadingState(isLoading) {
        this.addButtons?.forEach((button) => {
          button.classList.toggle("loading", isLoading);
        });
      }

      errorMessage() {
        this.toggleLoadingState(false);
      }

      success() {
        console.log("Product added to cart");
        this.toggleLoadingState(false);
        window.updateCartCount();
        window.toggleCartPopup(true);
        window.updateCartPopup();

        const quickView = this.closest("product-quick-view");
        if (quickView) quickView.classList.add("is-hidden");
      }

      variantError() {
        console.error("Product variant not selected");
      }

      removeErrorsBlock() {

      }

      openCartPopup() {

      }
    },
  );
}
